import { render, staticRenderFns } from "./politica-alcohol-drogas.vue?vue&type=template&id=4dcabb2f&scoped=true&"
import script from "./politica-alcohol-drogas.vue?vue&type=script&lang=js&"
export * from "./politica-alcohol-drogas.vue?vue&type=script&lang=js&"
import style0 from "./politica-alcohol-drogas.vue?vue&type=style&index=0&id=4dcabb2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcabb2f",
  null
  
)

export default component.exports